module.exports = __webpack_public_path__ + "img/newspapers_button_first_up.8ebb84da.png";